import { Head } from "@inertiajs/react"
import { AppLayout } from "../../components/layout/AppLayout"
import { CompanyForm } from "../../features/companies/CompanyForm"

type EditCompanyPageProps = {
  company: {
    id: number
    name: string
    cnpj: string
    omie_key: string
    omie_secret: string
    omie_email_copy: string
    modo_emissao: "web" | "txt" | "web_e_txt"
  }
  errors?: Record<string, string[]>
}

export default function EditCompanyPage({ company, errors }: EditCompanyPageProps) {
  return (
    <>
      <Head title="Editar Empresa" />
      <AppLayout>
        <div className="mx-auto w-full max-w-6xl p-8">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-white">Editar Empresa</h1>
            <p className="text-slate-400">Atualize credenciais Omie e modo de emissão.</p>
          </div>
          <CompanyForm
            initialValues={company}
            submitUrl={`/empresas/${company.id}`}
            submitLabel="Salvar alterações"
            method="patch"
            errors={errors}
          />
        </div>
      </AppLayout>
    </>
  )
}
